import React from 'react';
import { Shield, AlertTriangle, Mail } from 'lucide-react';
import { getAuthorizedDomainsList } from '../utils/domainAccess';

const AccessDenied = ({ user, reason }) => {
  const authorizedDomains = getAuthorizedDomainsList();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 bg-red-600 rounded-lg flex items-center justify-center">
            <Shield className="h-8 w-8 text-white" />
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Access Denied
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Your domain is not authorized to use this application
          </p>
        </div>

        <div className="card">
          <div className="space-y-6">
            <div className="text-center">
              <div className="flex items-center justify-center space-x-2 mb-4">
                <AlertTriangle className="h-6 w-6 text-red-600" />
                <h3 className="text-lg font-medium text-gray-900">
                  Unauthorized Domain
                </h3>
              </div>
              
              <p className="text-sm text-gray-600 mb-4">
                {reason || 'Your email domain is not authorized to access this application.'}
              </p>

              {user && (
                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <div className="flex items-center space-x-2">
                    <Mail className="h-5 w-5 text-gray-500" />
                    <span className="text-sm text-gray-700">{user.email}</span>
                  </div>
                </div>
              )}
            </div>

            <div>
              <h4 className="text-sm font-medium text-gray-900 mb-2">
                Authorized Domains:
              </h4>
              <div className="space-y-2">
                {authorizedDomains.map(domain => (
                  <div key={domain} className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    <span className="text-sm text-gray-600">@{domain}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h4 className="text-sm font-medium text-blue-900 mb-2">
                Need Access?
              </h4>
              <p className="text-sm text-blue-700">
                Contact your administrator to request access for your domain.
              </p>
            </div>

            <button
              onClick={() => window.location.reload()}
              className="w-full btn-secondary"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied; 